import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  CircularProgress,
  Alert,
} from '@mui/material';
import BaseInstance from '../../../Services/AxiosInstance/BaseInstance';
import { AgentTheme } from '../../../Shared-ui/Types/Agent';

interface ContactFormProps {
  onClose: () => void;
  conversationId: string; 
  agentTheme: AgentTheme;
}

const ContactForm: React.FC<ContactFormProps> = ({ onClose, agentTheme, conversationId }) => {
  console.log('[ContactForm] Component mounted/rendered!', { conversationId, agentTheme });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await BaseInstance.post("/conversations/form", {
      conversation_id: conversationId,
      name: formData.name,
      email: formData.email,
      phone_number: formData.phone,
    });

      setSuccess(true);
      // setTimeout(() => {
      //   onClose();
      // }, 2000); // Close form after 2 seconds on success
    } catch (err) {
      setError('Failed to submit the form. Please try again.');
      console.error('Form submission error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <Alert severity="success" sx={{ mt: 2 }}>
        Thank you! Your form has been submitted successfully.
      </Alert>
    );
  }

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: "1px solid #ddd",
        borderRadius: "12px",
        backgroundColor: "#fff",
      }}
    >
      <form onSubmit={handleSubmit}>
        <TextField fullWidth label="Name" name="name" size="small" sx={{ mb: 2 }} value={formData.name} onChange={handleChange} />
        <TextField fullWidth required label="Email" name="email" type="email" size="small" sx={{ mb: 2 }} InputLabelProps={{required: false,}} value={formData.email} onChange={handleChange} />
        <TextField fullWidth label="Phone Number" name="phone" size="small" sx={{ mb: 2 }} value={formData.phone} onChange={handleChange} />
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={submitting}
          sx={{
            textTransform: "none",
            backgroundColor: agentTheme.chatBubbleButtonColor,
            "&:hover": {
              backgroundColor: agentTheme.chatBubbleButtonColor,
              opacity: 0.9,
            },
          }}
        >
          {submitting ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
        </Button>
      </form>
    </Box>
  );
};

export default ContactForm;